<template>
    <b-modal :active.sync="isModalActive" :width="1028" scroll="keep" :can-cancel="canCancel" @close="closeModal">
        <div class="border border-blue-light rounded shadow bg-white p-4">
            <form @submit.prevent="savePermitting" class="w-full">
                <header class="font-thin uppercase text-blue-light modal-card-head_ mb-4">
                    {{ $t('add_permitting') }} / {{ $t('edit_permitting') }}
                </header>
                <div class="modal-card-body_ relative">
                    <div class="border-grey-light border-b border-dashed mb-3">
                        <div class="w-full flex flex-row mb-3">
                            <div class="w-1/2 pr-4">
                                <b-field :label="$t('select_permitting')" :message="templateError"
                                    :type="templateError ? 'is-danger' : ''">
                                    <treeselect v-model="selectTemplate" :options="templateTree"
                                        :disable-branch-nodes="true" :placeholder="$t('select_permitting')"
                                        :clearable="false" @input="onTemplateSelect" :disabled="disabledPermitting"/>
                                </b-field>
                            </div>
                            <div class="w-1/2 pr-4">
                                <b-field :label="$t('select_activity')" :message="activityError"
                                    :type="activityError ? 'is-danger' : ''">
                                  <treeselect
                                        v-model="selectActivity"
                                        :options="activities"
                                        :clearable="false"
                                        :disable-branch-nodes="false"
                                        :searchable="true"
                                        placeholder="Selecciona una actividad"
                                        @input="onActivitySelect"
                                    />
                                </b-field>
                            </div>
                        </div>
                        <!-- TODO: se comenta por si en un futuro se vuelve a usar estos campos -->
                        <!-- <div class="w-full flex flex-row mb-3">
                            <div class="w-1/4 pr-4">
                                 <b-field :label="$t('planning_date')">
                                    <b-datepicker
                                        v-model="form.planning_date"
                                        :placeholder="$t('select_date')"
                                        :locale="'es-ES'"
                                        icon-pack="fas"
                                        icon="calendar"
                                        :editable="true"
                                        :disabled="true"
                                    />
                                </b-field>
                            </div>
                            <div class="w-1/4 pr-4">
                                <b-field :label="$t('request_date')">
                                    <b-datepicker v-model="form.request_date" :placeholder="$t('select_date')"
                                        :locale="'es-ES'" icon-pack="fas" icon="calendar"
                                        :icon-right="form.request_date ? 'times' : ''" icon-right-clickable
                                        @icon-right-click="form.request_date = null" :editable="true" />
                                </b-field>
                            </div>
                            <div class="w-1/4 pr-4">
                                <b-field :label="$t('obtention_date')" :message="obtentionDateError"
                                    :type="obtentionDateError ? 'is-danger' : ''">
                                    <b-datepicker v-model="form.obtention_date" :placeholder="$t('select_date')"
                                        :locale="'es-ES'" icon-pack="fas" icon="calendar"
                                        :icon-right="form.obtention_date ? 'times' : ''" icon-right-clickable
                                        @icon-right-click="form.obtention_date = null" :editable="true" />
                                </b-field>
                            </div>
                            <div class="w-1/4 pr-4">
                                <b-field :label="$t('expiration_date')" :message="expirationDateError"
                                    :type="expirationDateError ? 'is-danger' : ''">
                                    <b-datepicker v-model="form.expiration_date" :placeholder="$t('select_date')"
                                        :locale="'es-ES'" icon-pack="fas" icon="calendar"
                                        :icon-right="form.expiration_date ? 'times' : ''" icon-right-clickable
                                        @icon-right-click="form.expiration_date = null" :editable="true" />
                                </b-field>
                            </div>
                        </div> -->
                      <!-- STATUS -->
                    <div class="w-full flex flex-row items-center justify-start mb-3">
                        <div class="w-1/4 pr-4">
                            <b-field :label="$t('response_date')">
                                <b-datepicker
                                    v-model="form.response_date"
                                    :placeholder="$t('select_date')"
                                    :locale="'es-ES'"
                                    icon-pack="fas"
                                    icon="calendar"
                                    :editable="true"
                                    :icon-right="form.response_date ? 'times' : ''"
                                    icon-right-clickable
                                    @icon-right-click="form.response_date = null"
                                />
                            </b-field>
                        </div>
                        <div class="w-1/4 pr-4">
                            <b-field :label="$t('status')">
                                <b-select v-model="form.status">
                                    <option :value="0">{{ $t('approved') }}</option>
                                    <option :value="1">{{ $t('approved_with_comments') }}</option>
                                    <option :value="2">{{ $t('rejected') }}</option>
                                    <option :value="3">{{ $t('rejected_with_comments') }}</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="w-1/4 pr-4">
                            <b-field :label="$t('expiration_date')" :message="expirationDateError"
                                :type="expirationDateError ? 'is-danger' : ''">
                                <b-datepicker v-model="form.expiration_date" :placeholder="$t('select_date')"
                                    :locale="'es-ES'" icon-pack="fas" icon="calendar"
                                    :icon-right="form.expiration_date ? 'times' : ''" icon-right-clickable
                                    @icon-right-click="form.expiration_date = null" :editable="true" />
                            </b-field>
                        </div>
                        </div>
                    </div>
                </div>
                <footer class="modal-card-foot_">
                    <div class="w-full inline-flex justify-end">
                        <button class="btn btn-blue" nativeType="submit" :disabled="processingData">
                            {{ $t('save') }}
                        </button>
                        <v-button-processing v-if="processingData" />
                    </div>
                </footer>
            </form>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect'
import moment from 'moment';
import Treeselect from '@riophae/vue-treeselect';
export default {
    props: {
        projectId: {
            type: Number,
            required: true,
        },
        loadingActivities: { type: Boolean, default: false },
        disabledPermitting: { type: Boolean, default: false }
    },
    components: {
        Multiselect,
        Treeselect
    },
    data() {
        return {
            canCancel: ['escape', 'x', 'outside'],
            form: {
                permitting_template_id: null,
                activity_id: '',
                // request_date: null,
                // obtention_date: null,
                // expiration_date: null,
                // planning_date: null,
                status:null,
                response_date: null
            },
            templates: [],
            activities: [],
            isModalActive: false,
            processingData: false,
            filteredActivities: [],
            filteredTemplates: [],
            templateError: null,
            activityError: null,
            selectTemplate: null,
            selectActivity: null,
            requestDateError: null,
            obtentionDateError: null,
            expirationDateError: null,
        }
    },
    computed: {
        hasErrors() {
            return this.requestDateError || this.obtentionDateError || this.expirationDateError;
        },
        templateTree() {
            const editingTemplateId = this.form.permitting_template_id;
            return this.templates.map(group => ({
                id: group.id,
                label: group.name,
                children: (group.templates || [])
                    .filter(tpl => {
                        // Solo cuenta los permisos del proyecto actual
                        const hasPermittingForThisProject = tpl.permittings && tpl.permittings.some(
                            p => p.activity && p.activity.project_id === this.projectId
                        );
                        return !hasPermittingForThisProject || tpl.id === editingTemplateId;
                    })
                   .map(tpl => ({
                        id: `template-${tpl.id}`,
                        label: `${tpl.code} - ${tpl.name}`,
                        isLeaf: true
                    }))
            })).filter(group => group.children.length > 0);
        },
    },
    watch: {
        // "form.request_date": "validateDates",
        // "form.obtention_date": "validateDates",
        // "form.expiration_date": "validateDates"
    },
    methods: {
        show(permitting, activities, templates) {
            this.activities = activities;
            this.templates = templates;
            this.filteredActivities = activities;

            if (permitting) {
                this.form = {
                    id: permitting.id,
                    permitting_template_id: permitting.permitting_template_id,
                    activity_id: permitting.activity_id,
                    request_date: permitting.request_date ? moment(permitting.request_date, 'YYYY-MM-DD').toDate() : null,
                    obtention_date: permitting.obtention_date ? moment(permitting.obtention_date, 'YYYY-MM-DD').toDate() : null,
                    expiration_date: permitting.expiration_date ? moment(permitting.expiration_date, 'YYYY-MM-DD').toDate() : null,
                    planning_date: permitting.planning_date ? moment(permitting.planning_date, 'YYYY-MM-DD').toDate() : null,
                    status: permitting.status ?? null,
                    response_date: permitting.response_date ? moment(permitting.response_date, 'YYYY-MM-DD').toDate() : null
                };

                this.selectTemplate = (permitting.permitting_template_id != null)
                ? `template-${permitting.permitting_template_id}`
                : null;

                let selectedActivity = this.findActivityById(this.activities, permitting.activity_id);
                this.selectActivity = selectedActivity ? selectedActivity.id : null;
            } else {
                this.resetForm();
            }
            this.isModalActive = true;
        },
        resetForm() {
            this.form = {
                id: null,
                permitting_template_id: null,
                activity_id: '',
                request_date: null,
                obtention_date: null,
                expiration_date: null,
                planning_date: null,
                status:null,
                response_date: null
            }
            this.selectTemplate = null;
            this.selectActivity = null;
        },
        closeModal() {
            this.isModalActive = false;
            this.resetForm();
        },
        onActivitySelect(selected) {
            this.form.activity_id = selected;
            const activity = this.findActivityById(this.activities, selected);
            if (activity && activity.current_start_date) {
                this.form.planning_date = moment(activity.current_start_date, 'DD/MM/YYYY').toDate();
            }
        },
        onTemplateSelect(selected) {
            if (selected && typeof selected === 'string' && selected.startsWith('template-')) {
                this.form.permitting_template_id = Number(selected.replace('template-', ''));
                this.selectTemplate = selected;
            } else {
                this.form.permitting_template_id = null;
                this.selectTemplate = null;
            }
        },
        handleInputChange(field) {
            return (value) => {
                if (field === 'permitting_template_id') {
                    this.filteredTemplates = this.templates.filter(template =>
                        template.name.toLowerCase().includes(value.toLowerCase())
                    );
                } else if (field === 'activity_id') {
                    this.filteredActivities = this.activities.filter(activity =>
                        activity.name.toLowerCase().includes(value.toLowerCase())
                    );
                }
            };
        },
        findActivityById(activities, activityId) {
            for (let activity of activities) {
                if (activity.id === activityId) {
                    return activity;
                }
                if (activity.children && activity.children.length) {
                    const subactivity = this.findActivityById(activity.children, activityId);
                    if (subactivity) return subactivity;
                }
            }
            return null;
        },
        async savePermitting() {
            this.processingData = true;
            let url = `/api/v2/project/${this.projectId}/permitting`;
            if (this.form.id) {
                url = `/api/v2/project/${this.projectId}/permitting/${this.form.id}`;
            }

            // Formatear las fechas antes de enviarlas
            const formattedForm = {
                ...this.form,
                request_date: this.form.request_date ? moment(this.form.request_date).format('YYYY-MM-DD') : null,
                obtention_date: this.form.obtention_date ? moment(this.form.obtention_date).format('YYYY-MM-DD') : null,
                expiration_date: this.form.expiration_date ? moment(this.form.expiration_date).format('YYYY-MM-DD') : null,
                planning_date: this.form.planning_date ? moment(this.form.planning_date).format('YYYY-MM-DD') : null,
                response_date: this.form.response_date ? moment(this.form.response_date).format('YYYY-MM-DD') : null,
            };

            try {
                await axios({
                    method: this.form.id ? 'put' : 'post',
                    url: url,
                    data: formattedForm
                });

                this.$buefy.toast.open({
                    message: this.$t('save_successful'),
                    type: 'is-success'
                });

                this.closeModal();
                this.$emit('reload-list');
                this.resetForm();
            } catch (error) {
                this.$buefy.toast.open({
                    message: this.$t('save_error'),
                    type: 'is-danger'
                });
            } finally {
                this.processingData = false;
            }
        },
        templateLabel(option) {
            return option.code;
        },
        validateDates() {
            const { request_date, obtention_date, expiration_date } = this.form;

            // Validación request_date
            if (request_date && obtention_date && request_date > obtention_date) {
                this.requestDateError = this.$t('date_request_greater_than_date_obtention');
            } else if (request_date && expiration_date && request_date > expiration_date) {
                this.requestDateError = this.$t('date_request_greater_than_date_expiration');
            } else {
                this.requestDateError = null;
            }

            // Validación obtention_date
            if (obtention_date && request_date && obtention_date < request_date) {
                this.obtentionDateError = this.$t('date_obtention_less_than_date_request');
            } else if (obtention_date && expiration_date && obtention_date > expiration_date) {
                this.obtentionDateError = this.$t('date_obtention_greater_than_date_expiration');
            } else {
                this.obtentionDateError = null;
            }

            // Validación expiration_date
            if (expiration_date && request_date && expiration_date < request_date) {
                this.expirationDateError = this.$t('date_expiration_less_than_date_request');
            } else if (expiration_date && obtention_date && expiration_date < obtention_date) {
                this.expirationDateError = this.$t('date_expiration_less_than_date_obtention');
            } else {
                this.expirationDateError = null;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .modal-content {
    overflow: visible !important;
}
</style>